import React from 'react'

import MoleculeCheckboxField from '@s-ui/react-molecule-checkbox-field'
import IconUnchecked from '@adv-mt/mt-svg-icons/lib/CheckboxEmpty.js'
import IconChecked from '@adv-mt/mt-svg-icons/lib/CheckboxFilled.js'
import IconIndeterminate from '@adv-mt/mt-svg-icons/lib/CheckboxIntermediate.js'

const CHECKBOX_ICON_TEST_ID = 'checkbox-check-icon'

const FormCheckboxField = props => {
  return (
    <MoleculeCheckboxField
      {...props}
      checkedIcon={IconChecked}
      uncheckedIcon={IconUnchecked}
      indeterminateIcon={IconIndeterminate}
      data-testid={CHECKBOX_ICON_TEST_ID}
    />
  )
}

FormCheckboxField.displayName = 'FormCheckboxField'

export default FormCheckboxField
